import React, { FC } from 'react';
import './Toggle.scss';

interface ToggleProps {
  isActive: boolean;
  onToggle: (newState: boolean) => void;
  labelInactive?: string;
  labelActive?: string;
  activeIcon?: React.ReactNode;  
  inactiveIcon?: React.ReactNode; 
}

const Toggle: FC<ToggleProps> = ({
  isActive,
  onToggle,
  activeIcon,
  inactiveIcon
}) => {
  const handleClick = () => {
    onToggle(!isActive);
  };

  return (
    <div className="toggle-container">
      <button 
        className={`toggle-switch ${isActive ? 'active' : 'inactive'}`} 
        onClick={handleClick}
      >
        <span className="toggle-thumb">
          {isActive ? (activeIcon || null) : (inactiveIcon || null)}
        </span>
      </button>
    </div>
  );
};

export default Toggle;
